/**
 * Creates a new object with all object's own enumerable properties that pass the test implemented by the provided function.
 * @param {Object} object
 * @param {Function} filter is a predicate, to test each property of the object. Return true to keep the property, false otherwise. It accepts three arguments:
 * @param {*} [context] Optional. Value to use as this when executing callback.
 * @returns {Object} A new object with the properties that pass the test. If no property pass the test,
 * an empty object will be returned.
 */
export const filter = (object, filter, context) =>
  Object
    .entries(object)
    .filter(([key, value]) => filter.call(context, value, key, object))
    .reduce((res, [key, value]) => {
      res[key] = value
      return res
    }, {})

/**
 * Creates a new object with the results of calling a provided function on every object's own enumerable properties.
 * @param {Object} object
 * @param {Function} mapper
 * @param {*} [context]
 * @returns {Object}
 */
export const map = (object, mapper, context) =>
  Object
    .entries(object)
    .reduce((res, [key, value]) => {
      res[key] = mapper.call(context, value, key, object)
      return res
    }, {})

/**
 * @param {Object} object
 * @returns {Object}
 */
export const reduce = (object) =>
  Object
    .values(object)
    .reduce((res, val) => ({ ...res, ...val }))

/**
 * Checks if object contains no own properties
 * @param {Object} object
 * @returns {boolean}
 */
export const isEmpty = object => Object.keys(object).length === 0

export const forEach = (object, cb, context) =>
  Object
    .entries(object)
    .forEach(([key, value]) => cb.call(context, value, key, object))
